"use client";
import React from "react";
import Pill from "../common/Pill";
import AIAgent from "../../assets/image7.svg";
import QRCode from "../../assets/image 3.svg";
import CustomersEngage from "../../assets/image10.svg";

const steps = [
  {
    title: "Create Your AI Agent",
    description: "Create your AI agent in minutes with our no-code builder.",
    icon: AIAgent,
  },
  {
    title: "Place Your QR Code",
    description: "Place your QR code anywhere customers can scan it.",
    icon: QRCode,
  },
  {
    title: "Let Customers Engage",
    description: "Let customers talk and get instant answers on the spot.",
    icon: CustomersEngage,
  },
];

const GetStarted = () => {
  return (
      <section className="bg-[#FFF7EB] py-12 sm:py-16 ">
       <div className="flex flex-col text-center items-center gap-4 sm:gap-[16px] max-w-6xl mx-auto  px-4">
  <Pill text="Get Started Fast" backgroundColor="#F3E6E6" />
  <h2 className="text-2xl sm:text-3xl md:text-5xl text-[#272020] font-semibold mt-2 sm:mt-4 leading-snug">
    3 Simple Steps to Launch AgoraVoice
  </h2>
  <p className="text-gray-600 mb-8 sm:mb-12 text-sm sm:text-base md:text-lg leading-relaxed">
    Go from AgoraVoice platform to QR code to AI assistant in minutes.{" "}
    <br className="hidden sm:block" />
    No coding, no hassle.
  </p>

  {/* Steps Container */}
  <div className="w-full max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-stretch gap-6">
    {steps.map((step, index) => (
      <div
        key={index}
        className={`flex flex-col justify-between gap-6 text-white rounded-xl p-5 sm:p-6 shadow-md w-full sm:w-[31%] transition-transform hover:scale-[1.02]
          ${
            index === 1
              ? "bg-gradient-to-l from-[rgb(29,28,28)] to-[#450800]"
              : "bg-black"
          }
        `}
      >
        <div className="flex flex-row gap-2 items-center">
          <h3 className="text-sm sm:text-base font-light">0{index + 1}</h3>
          <h3 className="text-sm sm:text-base font-medium">{step.title}</h3>
        </div>

        <div className="flex justify-center">
          <img
            src={step.icon}
            alt={step.title}
            className="w-[80%] sm:w-full h-auto object-contain"
          />
        </div>

        <p className="font-light text-gray-300 text-xs sm:text-sm md:text-base text-center sm:text-left">
          {step.description}
        </p>
      </div>
    ))}
  </div>
</div>

        <div className="flex justify-center mt-10 sm:mt-[50px] px-4">
          <a
            href="https://app.agoravoice.ai"
            target="_blank"
            rel="noopener noreferrer"
            className={`w-full sm:w-auto inline-block text-center
              text-base sm:text-lg md:text-xl
              bg-gradient-to-r from-[#B22222] to-[#FF4D4D]
              font-semibold border border-gray-400 text-white
              px-6 py-3 sm:px-8 sm:py-4
              rounded-full
              hover:scale-105 transition-transform`}
          >
            Try For Free
          </a>
        </div>
      </section>
  );
};

export default GetStarted;
